import { useState } from 'react';

import { Box } from '@zillow/constellation-10';

import DayChips from './DayChips';
import NoToursForDayCard from './NoToursForDayCard';
import TourEventCard from './TourEventCard';
import { dayEventListStyles, eventCardListStyles } from './styles';
import type { ToursSummaryDayChipType } from './types';
import type { UpcomingToursDay } from '../../hooks/useUpcomingToursData';

type DayEventListProps = {
  days: Array<UpcomingToursDay>;
  inquiriesPath: string;
  onDayChipClick?: (chip: ToursSummaryDayChipType) => void;
  onTourCardClick?: () => void;
};

const DayEventList = ({ days, inquiriesPath, onDayChipClick, onTourCardClick }: DayEventListProps) => {
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const events = days[selectedDayIndex]?.events ?? [];

  const handleDayChipSelect = (dayIndex: number, chip: ToursSummaryDayChipType) => {
    setSelectedDayIndex(dayIndex);
    onDayChipClick?.(chip);
  };

  return (
    <Box css={dayEventListStyles}>
      <DayChips days={days} selectedIndex={selectedDayIndex} onSelect={handleDayChipSelect} />

      {events.length > 0 ? (
        <Box css={eventCardListStyles}>
          {events.map((event) => (
            <TourEventCard key={event.tourId} event={event} inquiriesPath={inquiriesPath} onClick={onTourCardClick} />
          ))}
        </Box>
      ) : (
        <NoToursForDayCard />
      )}
    </Box>
  );
};

export default DayEventList;
